import { render, staticRenderFns } from "./TagsOverview.vue?vue&type=template&id=bdf48590&scoped=true"
import script from "./TagsOverview.vue?vue&type=script&lang=js"
export * from "./TagsOverview.vue?vue&type=script&lang=js"
import style0 from "./TagsOverview.vue?vue&type=style&index=0&id=bdf48590&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf48590",
  null
  
)

export default component.exports